var n=function(n,t){return null!=n&&t in Object(n)};export{n as default};
//# sourceMappingURL=_baseHasIn.js.map
